﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1.

export const edecideApiDev = "https://sbb-edecide-dev.azurewebsites.net";
export const edecideApiLocal = "https://localhost:5001";
export const edecideApiProd = "https://sbb-edecide.azurewebsites.net";
export const edecideApiTest = "https://sbb-edecide-test.azurewebsites.net";
export const edecideCnameDev = "https://edecide-deve.sbb.ch";
export const edecideCnameProd = "https://edecide.sbb.ch";
export const edecideCnameTest = "https://edecide-test.sbb.ch";
export const edecideSpaDev = "https://black-smoke-0ecfb2a03.6.azurestaticapps.net";
export const edecideSpaLocal = "https://localhost:3000";
export const edecideSpaProd = "https://green-smoke-04ce8f803.6.azurestaticapps.net";
export const edecideSpaTest = "https://ashy-sea-05c30fd03.6.azurestaticapps.net";
